import EventsProvider from './Provider';

export { default as useEventsContext } from './useEventsContext';

export default EventsProvider;